import React from 'react';

import './Spinner.css';

const Spinner = () => (
    <div className='spinner__container'>
        <div className="spinner"></div>
    </div>
);

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js